import {MainApp} from './MainApp.js'
window.MainApp = MainApp;
